'use client'

import { Button } from '../shadcn/button'
import Image from 'next/image'
import Link from 'next/link'
import { useModal } from '@/ui/context/ModalContext'
import WhatsappModal from '@/ui/context/modals/Whatsapp'
import { getFormattedWhatsappMessage } from '@/lib/whatsapp'
import { Product } from '@/payload-types'
import { useEffect, useState } from 'react'

export default function ContentButtons({ product }: { product: Product | null }) {
    const { openModal, whatsappData } = useModal()
    const [offerMessage, setOfferMessage] = useState('')
    const phoneNumber = whatsappData?.chatNumber ? whatsappData.chatNumber.replace(/^\+/, '') : '221770975523'

    useEffect(() => {
        const fetchMessage = async () => {
            const message = await getFormattedWhatsappMessage({ product, newOffer: true })
            setOfferMessage(message)
        }
        if (product) {
            fetchMessage()
        }
    }, [product])

    const handleOfferClick = () => {
        if (offerMessage) {
            window.open(`https://wa.me/${phoneNumber}?text=${offerMessage}`, '_blank')
        }
    }

    return (
        <div className="flex flex-col items-stretch gap-4">
            <Link href={`/order?productId=${product?.id}`}>
                <Button className="w-full flex items-center gap-3" size="xl">
                    <Image
                        src={
                            'https://res.cloudinary.com/dr04tcjag/image/upload/v1741485263/cart_tgjvt8.svg'
                        }
                        alt="dundshop logo"
                        width={26}
                        height={40}
                    />
                    <span>Achetez maintenant</span>
                </Button>
            </Link>
            {/* <Link href="https://wa.me/+221770975523" target='_blank'> */}
                <Button variant="dark" className="w-full flex items-center gap-3" size="xl" onClick={() => openModal(<WhatsappModal product={product} />)}>
                    <Image
                        src={
                            'https://res.cloudinary.com/dr04tcjag/image/upload/v1741485266/whatsapp_egnfsn.svg'
                        }
                        alt="dundshop logo"
                        width={28}
                        height={40}
                    />
                    <span>Commander par message</span>
                </Button>
            {/* </Link> */}
            <Button variant="outlineSolid" className="w-full flex items-center gap-3" size="xl" onClick={handleOfferClick} disabled={!offerMessage}>
                <span>Proposer un prix</span>
            </Button>
        </div>
    )
}
